import { createQueryKeys } from "@lukemorales/query-key-factory";

import { publicApi } from "@/api/axios";
import {
  onboardingExchangeResponseSchema,
  onboardingStatusResponseSchema,
} from "@/domains/profile/models/schemas";

const getOnboardingContext = async (token: string) => {
  const response = await publicApi.post("/auth/oidc/onboarding/exchange", { token });

  return onboardingExchangeResponseSchema.parse(response.data).data;
};

const getOnboardingStatus = async (token: string) => {
  const response = await publicApi.post("/auth/oidc/onboarding/status", { token });

  return onboardingStatusResponseSchema.parse(response.data).data;
};

export const personifyQueryOptions = createQueryKeys("personify", {
  onboardingExchange: (token: string) => {
    return {
      queryKey: [token],
      queryFn: () => {
        return getOnboardingContext(token);
      },
    };
  },
  onboardingStatus: (token: string) => {
    return {
      queryKey: [token],
      queryFn: () => {
        return getOnboardingStatus(token);
      },
    };
  },
});
